import { MSG, MESSAGES, REGEX } from "./const";
export const validateAdminField = (
  name: string,
  value: string
): string => {
  switch (name) {
    case "name":
      if (!value) return MSG.FULLNAME_REQUIRED;
      if (value.length < 2) return "Name must be more then 1 character";
      return "";
    case "email":
      if (!value) return MESSAGES.EMAIL_REQUIRED;
      if (!REGEX.EMAIL.test(value)) return MESSAGES.EMAIL_VALID;
      return "";
    case "password":
      if (!value) return MESSAGES.PASS_REQUIRED;
      if (value.length < 8) return MESSAGES.PASSWORD_MIN;
      if (!REGEX.UPPERCASE.test(value)) return MESSAGES.PASSWORD_UPPER;
      if (!REGEX.LOWERCASE.test(value)) return MESSAGES.PASSWORD_LOWER;
      if (!REGEX.NUMBER.test(value)) return MESSAGES.PASSWORD_NUMBER;
      if (!REGEX.SPECIAL_CHAR.test(value)) return MESSAGES.PASSWORD_SPECIAL;
      return "";
    case "phone":
      if (!value) return MSG.PHONE_REQUIRED;
      if (!MSG.PHONE_REGEX.test(value)) return MSG.PHONE_INVALID;
      return "";
    case "postcode":
      if (!value) return MSG.POSTCODE_REQUIRED;
      if (!MSG.POSTCODEREG.test(value)) return MSG.POSTCODE_INVALID;
      return "";
    case "country":
      if (!value) return MSG.COUNTRY_REQUIRED;
      return "";
    case "address":
      if (!value) return MSG.ADDRESS_REQUIRED;
      if (value.length < 5) return MSG.ADDRESS_MIN;
      return "";
    default:
      return "";
  }
};
export const isAdminFormValid = (
  formData: {
    name: string;
    email: string;
    password?: string;
    phone: string;
    postcode: string;
    country: string;
    address: string;
  },
  isEditMode: boolean = false
) => {
  const isPasswordValid = isEditMode
    ? true
    : !validateAdminField("password", formData.password || "");

  return (
    formData.name.length >= 2 &&
    REGEX.EMAIL.test(formData.email) &&
    isPasswordValid &&
    MSG.PHONE_REGEX.test(formData.phone) &&
    MSG.POSTCODEREG.test(formData.postcode) &&
    !!formData.country &&
    formData.address.length >= 5
  );
};


export const validateClassField = (
  name: string,
  value: string
): string => {
  switch (name) {
    case "className":
      if (!value) return "Class name is required";
      if (value.length < 2) return "Class name must be at least 2 characters";
      if (!/^(?=.*[A-Za-z])[A-Za-z0-9 &_-]+$/.test(value)) return "Invalid Name";
      return "";
    case "style":
      if (!value) return "Style is required";
      return "";
    case "instructorName":
      if (!value) return "Instructor name is required";
      return "";
    case "classType":
      if (!value) return "Class type is required";
      return "";
    case "startTime":
      if (!value) return "Start time is required";
      return "";
    case "endTime":
      if (!value) return "End time is required";
      return "";
    case "day":
      if (!value) return "Day is required";
      return "";
    case "coverImage":
      if (!value) return "Cover image is required";
      return "";
    case "description":
      if (!value) return "Description is required";
      return "";
    default:
      return "";
  }
};

const toMinutes = (time: string) => {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};

export const isClassFormValid = (formData: {
  className: string;
  style: string;
  instructorName: string;
  classType: string;
  day: string;
  startTime: string;
  endTime: string;
}) => {
  if (validateClassField("className", formData.className)) return false;
  if (validateClassField("style", formData.style)) return false;
  if (validateClassField("instructorName", formData.instructorName)) return false;
  if (validateClassField("classType", formData.classType)) return false;
  if (validateClassField("startTime", formData.startTime)) return false;
  if (validateClassField("endTime", formData.endTime)) return false;
  if (validateClassField("day", formData.day)) return false;
 if (
    formData.startTime &&
    formData.endTime &&
    toMinutes(formData.startTime) >= toMinutes(formData.endTime)
  ) {
    return false;
  }
  return true;
};
export const validateInstructorField = (
  name: string,
  value: string
): string => {
  switch (name) {
    case "fullname":
      if (!value) return "Full name is required";
      if (value.length < 2) return "Name must be at least 2 characters";
      if (!/^[A-Za-z\s]+$/.test(value)) return "Name can only contain letters and spaces";
      return "";
    case "instructorId":
      if (!value) return "Instructor ID is required";

      if (!/^UGI\d+$/.test(value)) return "ID must start with UGI followed by numbers (e.g. UGI001)";
      return "";
    case "email":
      if (!value) return "Email is required";
     
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "Invalid email address";
      return "";
    case "contactNumber":
      if (!value) return MSG.PHONE_REQUIRED;
      if (!MSG.PHONE_REGEX.test(value)) return MSG.PHONE_INVALID;
      return "";
    case "address":
      if (!value) return MSG.ADDRESS_REQUIRED;
      if (value.trim().length < 5) return MSG.ADDRESS_MIN;
      return "";
    default:
      return "";
  }
};
export const isInstructorFormValid = (formData: {
  fullName: string;
  instructorId: string;
  email: string;
  contactNumber: string;
  address: string;
 
}) => {
  if (validateInstructorField("fullName", formData.fullName)) return false;
  if (validateInstructorField("instructorId", formData.instructorId)) return false;
  if (validateInstructorField("email", formData.email)) return false;
  if (validateInstructorField("contactNumber", formData.contactNumber)) return false;
  if (validateInstructorField("address", formData.address)) return false;
  
  return true;
};
